module.exports = __webpack_public_path__ + "static/media/logo_cnseg.9c677706.png";